'use client';
import { getDefaultZIndex } from '@s7/styles';

var COMPONENT_ID = "Popover";
var defaultTransitionProps = {
    transition: "fade",
    duration: 150
};
var defaultMiddlewares = {
    flip: true,
    shift: true,
    inline: false
};
var defaultProps = {
    position: "bottom",
    shadow: "z100",
    offset: 8,
    positionDependencies: [],
    transitionProps: defaultTransitionProps,
    middlewares: defaultMiddlewares,
    arrowSize: 7,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    closeOnClickOutside: true,
    withinPortal: false,
    closeOnEscape: true,
    trapFocus: false,
    withRoles: true,
    returnFocus: false,
    clickOutsideEvents: [
        "mousedown",
        "touchstart"
    ],
    zIndex: getDefaultZIndex("popover"),
    __staticSelector: "Popover",
    width: "max-content"
};

export { COMPONENT_ID, defaultMiddlewares, defaultProps, defaultTransitionProps };
